<template>
  <div class="playground-detail" v-if="storeContent">
    <div class="item" v-if="storeContent.ground_info">
      <div class="title">场馆信息</div>
      <div class="text"
        ><p v-html="storeContent.ground_info"></p
      ></div>
    </div>
    <div class="item" v-if="storeContent.ground_service">
      <div class="title">场馆服务</div>
      <div class="text"
        ><p v-html="storeContent.ground_service"></p
      ></div>
    </div>
    <div class="item" v-if="storeContent.ground_notice">
      <div class="title">入场须知</div>
      <div class="text"
        ><p v-html="storeContent.ground_notice"></p
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storeContent: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>
<style lang='less' scoped>
.playground-detail {
  .item {
    padding: .2rem;
    line-height: .45rem;
    color: #000;
    border-radius: .08rem;
    background: #fff;
    margin-top: .2rem;
    .title {
      font-size: .34rem;
      font-weight: bold;
      color: #333333;
      padding-bottom: .1rem;
      padding-top: .1rem;
    }
    p{
      font-size: .34rem;
    }
  }
}
</style>
